import script from "./ai-text-generator-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ai-text-generator-modal.vue?vue&type=script&setup=true&lang=ts"

import "./ai-text-generator-modal.vue?vue&type=style&index=0&id=20d3b3c9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d3b3c9"]])

export default __exports__